import React from "react";
import FlexView from "./FlexView";

export default function Flex({ children }) {
  return <FlexView>{children}</FlexView>;
}
